// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Storage from 'vue-ls'
import config from '@/defaultSettings'
import './permission'
import Vant from 'vant'
import './utils/vconsole'
import 'vant/lib/index.css'
// eslint-disable-next-line
// 全局组件
// 使用use 使用
Vue.config.productionTip = false
Vue.use(Storage, config.storageOptions)
Vue.use(Vant)
window.document.title = '幸福公社-会员中心'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js